// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  IAchReturnResponseDto,
  ICheckReissueDto,
  ICheckVoidDto,
  IErrorDto,
  IPaymentMethodResponseDto,
} from '../models/index';
import {
    IAchReturnResponseDtoFromJSON,
    IAchReturnResponseDtoToJSON,
    ICheckReissueDtoFromJSON,
    ICheckReissueDtoToJSON,
    ICheckVoidDtoFromJSON,
    ICheckVoidDtoToJSON,
    IErrorDtoFromJSON,
    IErrorDtoToJSON,
    IPaymentMethodResponseDtoFromJSON,
    IPaymentMethodResponseDtoToJSON,
} from '../models/index';

export interface ChangeDefaultPaymentMethodRequest {
    id: number;
}

export interface DeletePaymentMethodRequest {
    id: number;
}

export interface GetAchReturnByIndividualIdentificationNumberRequest {
    individualIdentificationNumber: string;
}

export interface GetPaymentMethodByIdRequest {
    id: number;
}

export interface PaymentReissueCheckByIdRequest {
    checkId: number;
    iCheckReissueDto: ICheckReissueDto;
}

export interface PaymentVoidCheckByIdRequest {
    checkId: number;
    iCheckVoidDto: ICheckVoidDto;
}

/**
 * PaymentServiceServiceApi - interface
 * 
 * @export
 * @interface PaymentServiceServiceApiInterface
 */
export interface PaymentServiceServiceApiInterface {
    /**
     * 
     * @summary Set new payment method as default
     * @param {number} id Payment method ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentServiceServiceApiInterface
     */
    changeDefaultPaymentMethodRaw(requestParameters: ChangeDefaultPaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPaymentMethodResponseDto>>;

    /**
     * Set new payment method as default
     */
    changeDefaultPaymentMethod(requestParameters: ChangeDefaultPaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPaymentMethodResponseDto>;

    /**
     * 
     * @summary Delete specific payment method (by id)
     * @param {number} id Payment method ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentServiceServiceApiInterface
     */
    deletePaymentMethodRaw(requestParameters: DeletePaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete specific payment method (by id)
     */
    deletePaymentMethod(requestParameters: DeletePaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get payment methods by recipient id (equals to employee id, retrieved from token)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentServiceServiceApiInterface
     */
    findByRecipientIdRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;

    /**
     * Get payment methods by recipient id (equals to employee id, retrieved from token)
     */
    findByRecipientId(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;

    /**
     * 
     * @summary Get ACH return
     * @param {string} individualIdentificationNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentServiceServiceApiInterface
     */
    getAchReturnByIndividualIdentificationNumberRaw(requestParameters: GetAchReturnByIndividualIdentificationNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IAchReturnResponseDto>>>;

    /**
     * Get ACH return
     */
    getAchReturnByIndividualIdentificationNumber(requestParameters: GetAchReturnByIndividualIdentificationNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IAchReturnResponseDto>>;

    /**
     * 
     * @summary Get payment method by id
     * @param {number} id Payment method ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentServiceServiceApiInterface
     */
    getPaymentMethodByIdRaw(requestParameters: GetPaymentMethodByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPaymentMethodResponseDto>>;

    /**
     * Get payment method by id
     */
    getPaymentMethodById(requestParameters: GetPaymentMethodByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPaymentMethodResponseDto>;

    /**
     * 
     * @summary Reissue check by id
     * @param {number} checkId 
     * @param {ICheckReissueDto} iCheckReissueDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentServiceServiceApiInterface
     */
    paymentReissueCheckByIdRaw(requestParameters: PaymentReissueCheckByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Reissue check by id
     */
    paymentReissueCheckById(requestParameters: PaymentReissueCheckByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Voiding check by id
     * @param {number} checkId 
     * @param {ICheckVoidDto} iCheckVoidDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentServiceServiceApiInterface
     */
    paymentVoidCheckByIdRaw(requestParameters: PaymentVoidCheckByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Voiding check by id
     */
    paymentVoidCheckById(requestParameters: PaymentVoidCheckByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class PaymentServiceServiceApi extends runtime.BaseAPI implements PaymentServiceServiceApiInterface {

    /**
     * Set new payment method as default
     */
    async changeDefaultPaymentMethodRaw(requestParameters: ChangeDefaultPaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPaymentMethodResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling changeDefaultPaymentMethod().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/payment-methods/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPaymentMethodResponseDtoFromJSON(jsonValue));
    }

    /**
     * Set new payment method as default
     */
    async changeDefaultPaymentMethod(requestParameters: ChangeDefaultPaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPaymentMethodResponseDto> {
        const response = await this.changeDefaultPaymentMethodRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete specific payment method (by id)
     */
    async deletePaymentMethodRaw(requestParameters: DeletePaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deletePaymentMethod().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/payment-methods/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete specific payment method (by id)
     */
    async deletePaymentMethod(requestParameters: DeletePaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePaymentMethodRaw(requestParameters, initOverrides);
    }

    /**
     * Get payment methods by recipient id (equals to employee id, retrieved from token)
     */
    async findByRecipientIdRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/payment-methods/recipient`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Get payment methods by recipient id (equals to employee id, retrieved from token)
     */
    async findByRecipientId(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.findByRecipientIdRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get ACH return
     */
    async getAchReturnByIndividualIdentificationNumberRaw(requestParameters: GetAchReturnByIndividualIdentificationNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IAchReturnResponseDto>>> {
        if (requestParameters['individualIdentificationNumber'] == null) {
            throw new runtime.RequiredError(
                'individualIdentificationNumber',
                'Required parameter "individualIdentificationNumber" was null or undefined when calling getAchReturnByIndividualIdentificationNumber().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/ach-returns/{individual_identification_number}`;
        urlPath = urlPath.replace(`{${"individual_identification_number"}}`, encodeURIComponent(String(requestParameters['individualIdentificationNumber'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IAchReturnResponseDtoFromJSON));
    }

    /**
     * Get ACH return
     */
    async getAchReturnByIndividualIdentificationNumber(requestParameters: GetAchReturnByIndividualIdentificationNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IAchReturnResponseDto>> {
        const response = await this.getAchReturnByIndividualIdentificationNumberRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get payment method by id
     */
    async getPaymentMethodByIdRaw(requestParameters: GetPaymentMethodByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPaymentMethodResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getPaymentMethodById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/payment-methods/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPaymentMethodResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get payment method by id
     */
    async getPaymentMethodById(requestParameters: GetPaymentMethodByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPaymentMethodResponseDto> {
        const response = await this.getPaymentMethodByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Reissue check by id
     */
    async paymentReissueCheckByIdRaw(requestParameters: PaymentReissueCheckByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['checkId'] == null) {
            throw new runtime.RequiredError(
                'checkId',
                'Required parameter "checkId" was null or undefined when calling paymentReissueCheckById().'
            );
        }

        if (requestParameters['iCheckReissueDto'] == null) {
            throw new runtime.RequiredError(
                'iCheckReissueDto',
                'Required parameter "iCheckReissueDto" was null or undefined when calling paymentReissueCheckById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/checks/{check_id}/reissue`;
        urlPath = urlPath.replace(`{${"check_id"}}`, encodeURIComponent(String(requestParameters['checkId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ICheckReissueDtoToJSON(requestParameters['iCheckReissueDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Reissue check by id
     */
    async paymentReissueCheckById(requestParameters: PaymentReissueCheckByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.paymentReissueCheckByIdRaw(requestParameters, initOverrides);
    }

    /**
     * Voiding check by id
     */
    async paymentVoidCheckByIdRaw(requestParameters: PaymentVoidCheckByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['checkId'] == null) {
            throw new runtime.RequiredError(
                'checkId',
                'Required parameter "checkId" was null or undefined when calling paymentVoidCheckById().'
            );
        }

        if (requestParameters['iCheckVoidDto'] == null) {
            throw new runtime.RequiredError(
                'iCheckVoidDto',
                'Required parameter "iCheckVoidDto" was null or undefined when calling paymentVoidCheckById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/checks/{check_id}/void`;
        urlPath = urlPath.replace(`{${"check_id"}}`, encodeURIComponent(String(requestParameters['checkId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ICheckVoidDtoToJSON(requestParameters['iCheckVoidDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Voiding check by id
     */
    async paymentVoidCheckById(requestParameters: PaymentVoidCheckByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.paymentVoidCheckByIdRaw(requestParameters, initOverrides);
    }

}
